import { actions } from "utils/helpers";
import Table from "components/Table/Table";
import { toast } from "react-hot-toast";
import { UNAUTHORIZED } from "constants";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Fragment, useCallback, useEffect } from "react";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import {
  useGetTrunksQuery,
  useDeleteTrunkMutation,
} from "features/trunk/trunkApiSlice";

import cardStyles from "styles/modules/Card.module.scss";

const Trunks = ({ label }) => {
  const navigate = useNavigate();

  const authUser = useSelector(selectAuthUser);

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetTrunksQuery(searchParams.toString());

  const dispatch = useDispatch();

  const [deleteTrunk] = useDeleteTrunkMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Trunks"));
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      toast.error(error || "Could not load trunks, try refreshing the page");
    }
  }, [isError, error]);

  const onEditBtnHandler = useCallback(
    (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.view)) {
        if (callFn) {
          navigate(`/trunks/${id}`);
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, label, navigate]
  );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteTrunk(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deleteTrunk, label]
  );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for trunks</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onEdit={onEditBtnHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Trunks;
